import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";

class ProductRecallDataAccess {
  getList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData("ProductRecall/getall", parameters);
  };


  saveProductRecallGeneralInfo = (data: any) => {
    return commonDataAccess.postData("ProductRecall/save/generalinfo", data);
  }

  getProductRecallGeneralInfoById = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "ProductRecall/getProductRecallGeneralInfo/" + params.id,
      {}
    );
    return result;
  };
  deleteProductRecall = (ids: number | number[]) => {
    if (Array.isArray(ids)) {
      return commonDataAccess.postData(
        "ProductRecall/deleteAll",
        ids
      );
    } else {
      return commonDataAccess.deleteData(
        `ProductRecall/delete/${ids}`
      );
    }
  };

  saveProductRecallDocuments = (payload: any) => {
    return commonDataAccess.postData("ProductRecall/save/documents", payload);
  };

  getProductRecallImmediateAction(productRecallId: number) {
    return commonDataAccess.getData(
      "ProductRecall/get/immediateAction",
      {
        productRecallId: productRecallId,
      }
    );
  }

  saveProductRecallImmediateActions = (payload: any) => {
    return commonDataAccess.postData("ProductRecall/save/immediateAction", payload);
  }

  sendProcessEmail = (
    productRecallId: any,
    assignUserId: any,
    resolveByDate: any
  ) => {
    return commonDataAccess.getData("ProductRecall/sendProcessEmail", {
      productRecallId: productRecallId,
      assignUserid: assignUserId,
      resovedByDate: resolveByDate,
    });
  };

  getProductRecallPreventativeAction(productRecallId: number) {
    return commonDataAccess.getData(
      "ProductRecall/get/preventativeAction",
      {
        productRecallId: productRecallId,
      }
    );
  }

  saveProductRecallPreventativeActions = (payload: any) => {
    return commonDataAccess.postData("ProductRecall/save/preventativeAction", payload);
  }

  getProductRecallRootCauseAnalysis(productRecallId: number) {
    return commonDataAccess.getData(
      "ProductRecall/get/rootCauseAnalysis",
      {
        productRecallId: productRecallId,
      }
    );
  }

  saveProductRecallRootCauseAnalysis = (payload: any) => {
    return commonDataAccess.postData("ProductRecall/save/rootCauseAnalysis", payload);
  }
  getProductRecallCommunicationNotification(productRecallId: number) {
    return commonDataAccess.getData(
      "ProductRecall/get/communicationNotification",
      {
        productRecallId: productRecallId,
      }
    );
  }

  saveProductRecallCommunicationNotification = (payload: any) => {
    return commonDataAccess.postData("ProductRecall/save/communicationNotification", payload);
  }

  getCommunicationNotification = (productRecallId: number, notificationType: string) => {
    return commonDataAccess.getData(
      "ProductRecall/get/communication-Notification",
      {
        productRecallId: productRecallId,
        notificationType: notificationType
      }
    );
  }

  saveCommunicationNotification = (payload: any, notificationType: string) => {
    return commonDataAccess.postData("ProductRecall/save/communication-Notification", payload, {
      notificationType: notificationType,
    }
    );
  }

  deleteCommunicationNotification = (id: number) => {
    return commonDataAccess.deleteData(`ProductRecall/deleteCommunicationNotification/${id}`);
  }

   closeDownRecall = (productRecallId: any) => {
      return commonDataAccess.getData(
        `ProductRecall/closeDownRecall/${productRecallId}`,
      );
    };

}
export default new ProductRecallDataAccess();
